import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'

export const useHasBrandHeartIcon = () => useBrand().brandThemeName === 'vio'
